@if (dataSourceData) {
  <h1>Data Source</h1>
  <div class="py-5">
    <form #productForm="ngForm" (ngSubmit)="saveDataSource()">

      <!-- Title -->
      <app-cards-basic title="{{ 'COMMON.title' | translate }}">
        @for (lang of _languageService.supportedLangs; track lang) {
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>{{ 'COMMON.title_' + lang | translate }}</mat-label>
            <input matInput
                   required
                   [(ngModel)]="dataSourceData.translations[lang].title"
                   name="productTitle_{{ lang }}">
          </mat-form-field>
        }
      </app-cards-basic>

    </form>

    @for(lang of _languageService.supportedLangs; track lang;){
      <app-table-editor
        [language]="lang"
        [dataInput]="dataSourceData.translations[lang].data_json"
        (outputChange)="outputChange($event, lang)"
        (copyDataOutput)="copyData($event)"
        (pasteChange)="pasteData(lang)"
      ></app-table-editor>
    }

    <!-- Actions -->
    <button mat-button
            color="primary"
            type="button"
            (click)="cancel()"
            class="bp-button">
      {{ 'ACTIONS.cancel' | translate }}
    </button>
    <button mat-flat-button
            color="primary"
            [disabled]="!productForm.valid"
            (click)="saveDataSource()"
            class="bp-button">
      {{ 'ACTIONS.save' | translate }}
    </button>
  </div>

}
